<template>
  <div ref="container" class="icon-calendar">
    <v-icon v-bind="$attrs" class="icon">
      $freshvue-calendar
    </v-icon>
    <span class="text" :style="{ 'font-size': fontSize }">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'IconCalendar',

  props: {
    date: {
      type: Date,
      required: false,
      default: () => new Date()
    }
  },

  data() {
    return {
      observer: null,
      height: 0
    }
  },

  computed: {
    theme() {
      return this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark
        : this.$vuetify.theme.themes.light
    },

    text() {
      let _return = null

      if (this.date) {
        _return = this.date.getDay()
      }

      return _return
    },

    fontSize() {
      let fontSize = this.height / 2 - 5

      if (fontSize <= 0) {
        fontSize = 0
      }

      return fontSize + 'px'
    }
  },

  mounted() {
    this.initHeight()
    this.initObserver()
  },

  beforeDestroy() {
    this.observer.disconnect()
  },

  methods: {
    getColor(color) {
      // If it is a color from the theme, than return it. Otherwise return the color.
      return this.theme[color] ? this.theme[color] : color
    },

    initHeight() {
      this.height = this.$refs.container.clientHeight
    },

    initObserver() {
      const vm = this

      this.observer = new MutationObserver(function(mutationsList, observer) {
        mutationsList.forEach(function(mutation) {
          if (mutation.type === 'attributes') {
            vm.height = mutation.target.clientHeight
          }
        })
      })

      this.observer.observe(this.$refs.container, {
        attributes: true,
        attributesList: ['clientHeight']
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-calendar {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .text {
    position: absolute;
    padding-top: 0.66em;
    // font-size: 0.75em; // Will be set inline (depends on icon size)
    text-align: center;
    font-weight: bold;

    user-select: none; // user shouldn't be able to select the text
  }
}
</style>
